import { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import AdminFooter from 'src/components/user-mobile/parking/admin/AdminFooter';
import ControlAll from 'src/components/user-mobile/parking/admin/setting/control/ControlAll';
import HeaderAll from 'src/components/user-mobile/parking/admin/setting/header/HeaderAll';
import ParkingAdminNotice from 'src/components/user-mobile/parking/admin/setting/notice/ParkingAdminNotice';
import SettingList from 'src/components/user-mobile/parking/admin/setting/control/SettingList';
import { instance } from 'src/apis';
import { ParkingPlace } from 'src/interfaces/user-mobile/parking.interface';
import { styled } from 'styled-components';
import { IFestivalOutlet } from 'src/interfaces/overview.interface';

export default function ParkingAdmin() {
  const [isAllOn, setIsAllOn] = useState(true);
  const [parkingPlaces, setParkingPlaces] = useState<ParkingPlace[]>([]);
  const [announcement, setAnnouncement] = useState('');
  const [announcementEnabled, setAnnouncementEnabled] = useState(false);
  const { festivalId } = useOutletContext<IFestivalOutlet>();

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      alert('로그인이 필요합니다.');
      navigate('/parking/admin/login');
      return;
    }
    fetchParkingData();
  }, [navigate]);

  const fetchParkingData = async () => {
    try {
      const res = await instance.get('/parking', {
        params: { festivalId },
      });
      setIsAllOn(res.data.congestionEnabled);
      setAnnouncement(res.data.announcement);
      setAnnouncementEnabled(res.data.announcementEnabled);

      const sortedPlaces = [...res.data.parkingPlaces].sort((a, b) => {
        if (a.area < b.area) return -1;
        if (a.area > b.area) return 1;
        const numA = parseInt(a.name.replace(/\D/g, ''), 10);
        const numB = parseInt(b.name.replace(/\D/g, ''), 10);
        return numA - numB;
      });

      setParkingPlaces(sortedPlaces);
    } catch (e) {
      console.error('데이터 로딩 실패', e);
    }
  };
  let parkingId = 0;
  if (festivalId === 7) {
    parkingId = 1;
  } else if (festivalId === 9) {
    parkingId = 2;
  }
  const handleAllSwitch = async (value: boolean) => {
    try {
      await instance.patch('/parking', null, {
        params: {
          parkingId,
          isCongestionEnabled: value,
        },
      });
      setIsAllOn(value);

      // 최신 데이터 가져오기
      const res = await instance.get('/parking', {
        params: { festivalId },
      });
      const places: ParkingPlace[] = res.data.parkingPlaces;

      // 모든 주차장 상태 업데이트
      await Promise.all(
        places.map(place =>
          Promise.all([
            instance.patch('/parking/place/state', null, {
              params: {
                parkingPlaceId: place.id,
                parkingPlaceEnabled: value,
              },
            }),
            instance.patch('/parking/place/congestion', null, {
              params: {
                parkingPlaceId: place.id,
                congestionLevel: 'LOW',
              },
            }),
          ]),
        ),
      );

      await fetchParkingData();
    } catch (e) {
      console.error('전체 스위치 변경 실패', e);
    }
  };

  return (
    <AdminPageContainer>
      <HeaderAll />
      <ParkingAdminNotice
        announcement={announcement}
        announcementEnabled={announcementEnabled}
        refetch={fetchParkingData}
        festivalId={festivalId}
      />
      <ControlAll
        isOn={isAllOn}
        setIsOn={handleAllSwitch}
        // festivalId={festivalId}
      />
      <SettingList
        isAllOn={isAllOn}
        parkingPlaces={parkingPlaces}
        refetch={fetchParkingData}
        // festivalId={festivalId}
      />
      <AdminFooter />
    </AdminPageContainer>
  );
}

const AdminPageContainer = styled.div`
  @media (min-width: 640px) {
    width: 640px;
    margin: 0 auto;
    background-color: #f4f3f4;
  }
`;
